export class JCVacancies {

	constructor(params) {
		this.node = {};
		this.vacancies = params.vacancies || {};
		this.currentCity = params.currentCity || 'irkutsk';
		this.currentCityVacancies = [];
		this.message = '';
		this.nodeIdList = {
			idVacancies: params.nodeIdList.idVacancies,
		};
		this.classList = {
			classContainer: params.classList.classContainer || 'footer-b__vacancy',
			classItem: params.classList.classItem || 'footer-b__vacancy-item'
		};

		BX.ready(BX.delegate(this.init, this));
	}

	init() {
		this.node.VacanciesContainer = BX(this.nodeIdList.idVacancies);

		if ( this.vacancies && this.vacancies.length > 0 ) {
			for(let index = 0; index < this.vacancies.length; index++) {
				if (this.vacancies[index]["IBLOCK_SECTION_CODE"] === this.currentCity) {
					this.currentCityVacancies.push(this.vacancies[index]);
				}
			}

			if(this.currentCityVacancies.length === 0) {
				this.message = BX.message('msg_emptyVacanciesInCity');
			}
		} else {
			this.message = BX.message('msg_emptyVacancies');
		}

		if(this.message.length > 0) {
			this.printMessages();
		} else {
			let items = [];
			items = this.createContentOfVacancies();

			for (let index = 0; index < items.length; index++) {
				this.node.VacanciesContainer.appendChild(items[index]);
			}

			if(this.currentCityVacancies.length > 2) {
				setInterval(() => { this.updateVacancies() }, 5000);
			}
		}
	}

	printMessages() {
		this.node.VacanciesContainer.appendChild(
			BX.create('DIV', {
				props: {
					className: this.classList.classItem,
				},
				text: this.message
			})
		);
	}

	createContentOfVacancies() {
		let randomIds = [],
			items = [],
			currentRandId;

		randomIds.push(this.getRandomInt(this.currentCityVacancies.length));

		if(this.currentCityVacancies.length > 1) {
			do {
				currentRandId = this.getRandomInt(this.currentCityVacancies.length);
			} while (randomIds[0] === currentRandId);
			randomIds.push(currentRandId);
		}

		for(let index = 0; index < randomIds.length; index++) {
			items.push(BX.create('DIV', {
				props: {
					className: this.classList.classItem,
				},
				text: this.currentCityVacancies[randomIds[index]]["~PREVIEW_TEXT"]
			}));
		}

		return items;
	}

	updateVacancies() {
		let items = [];
		items = this.createContentOfVacancies();
		$('.' + this.classList.classContainer).html(items);

		let divs = $('div.' + this.classList.classItem).hide();
		for(let i = 0; i < divs.length; i++) {
			divs.eq(i).fadeIn(400).delay(5000).fadeOut(400);
		}
	}

	getRandomInt(max) {
		return Math.floor(Math.random()*Math.floor(max));
	}

}